import React from "react";
import FilterIcon from "../../../components/icons/FilterIcon";
import { Link, useNavigate } from "react-router-dom";
import { clientRoutes } from "../../../utils/routes";
import { commonAction } from "../../../redux/features/commonSlice";
import { useDispatch } from "react-redux";
import "./ListTopButtonsAndSearch.scss";
import ResetIcon from "../../../components/icons/ResetIcon";
import SearchIcon from "../../../components/icons/SearchIcon";
import { CommonEnums } from "../../../enums/common.enums";
import ListFilterButton from "../buttons/ListFilterButton";

const ListTopButtonsAndSearch = ({
  add_btn_name,
  add_btn_link,
  reset_btn_link,
  placeholder,
  onChangeSearch,
  type,
  onClickRefresh,
  hideResetFilter = false,
}: {
  add_btn_name?: string;
  add_btn_link?: string;
  reset_btn_link: string;
  placeholder: string;
  onChangeSearch?: any;
  type: string;
  onClickRefresh?: () => void;
  hideResetFilter?: boolean;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onClickFilter = () => {
    dispatch(commonAction?.setHomePageFilter());
  };

  const resetFilter = () => {
    dispatch(commonAction?.resetFilter());
    navigate(reset_btn_link);
  };

  const onClickAgentAdd = () => {
    dispatch(commonAction?.addAgentsDialogBox());
  };

  const getButton = () => {
    switch (type) {
      case CommonEnums.pageTypes?.user?.key:
        return (
          <Link to={add_btn_link || ""} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );

      case CommonEnums.pageTypes?.subscriptions?.key:
        return (
          <Link to={add_btn_link || ""} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );

      case CommonEnums.pageTypes?.design_templates?.key:
        return (
          <Link to={add_btn_link || ""} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );

      case CommonEnums.pageTypes?.design_template_types?.key:
        return (
          <Link to={add_btn_link || ""} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );

      case CommonEnums.pageTypes?.agents?.key:
        return <button className="send-invite-btn">{add_btn_name}</button>;

      case CommonEnums.pageTypes?.agencies?.key:
        return <button className="send-invite-btn">{add_btn_name}</button>;

      case CommonEnums.pageTypes?.referral_programs?.key:
        return (
          <Link to={add_btn_link || ""} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );

      case CommonEnums.pageTypes?.referral_programs_agents?.key:
        return (
          <button className="send-invite-btn" onClick={onClickAgentAdd}>
            {add_btn_name}
          </button>
        );

      case CommonEnums.pageTypes?.referral_programs_agencies?.key:
        return (
          <button className="send-invite-btn" onClick={onClickAgentAdd}>
            {add_btn_name}
          </button>
        );

      case CommonEnums.pageTypes?.property_stages?.key:
        return (
          <Link to={add_btn_link || ""} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );

      case CommonEnums.pageTypes?.manual_wallet_points?.key:
        return (
          <Link to={add_btn_link || ""} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );
    }
  };

  return (
    <div className="list-top-buttons-and-search-container">
      {type === CommonEnums.pageTypes?.referral_programs?.key ? (
        <div></div>
      ) : (
        <div className="search-contain">
          <div className="search-icon">
            <SearchIcon />
          </div>
          <input
            type="text"
            placeholder={placeholder}
            className="search-input"
            onChange={onChangeSearch}
          />
        </div>
      )}

      <div className="list-top-buttons-container">
        {onClickRefresh && (
          <button className="list-top-refresh-btn" onClick={onClickRefresh}>
            <div className="refresh-icon">
              <ResetIcon />
            </div>
            {/* <p>Refresh</p> */}
          </button>
        )}
        {/* {!hideResetFilter && (
          <button className="list-top-filter-btn" onClick={resetFilter}>
            <div className="filter-icon">
              <ResetIcon />
            </div>
            <p> Reset Filters</p>
          </button>
        )} */}

        <ListFilterButton />
        {getButton()}
      </div>
    </div>
  );
};

export default ListTopButtonsAndSearch;
